import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
    'use strict';

    angular
        .module('travelControllers')
        .factory('travelService', service);

    service.$inject = ['$http'];

    function service($http) {
        var baseUrl = environment.apiUrl + '/Pilot/api/Travel';

        return {

            // ==== Governance Process ====

            // Create
            createGovernanceProcess: function (governanceProcess) {
                return $http
                    .post(baseUrl + '/GovernanceProcess', governanceProcess)
                    .then(function (response) { return response.data; })
            },
            // Update
            updateGovernanceProcess: function (governanceProcess) {
                return $http
                    .put(baseUrl + '/GovernanceProcess/' + governanceProcess.GovernanceProcessID, governanceProcess)
                    .then(function (response) { return response.data; })
            },

            // Get by id
            getGovernanceProcessByID: function (governanceProcessID) {
                return $http
                    .get(baseUrl + '/GovernanceProcess/' + governanceProcessID)
                    .then(function (response) { return response.data; });
            },

            // Get Active
            getActiveGovernanceProcess: function () {
                return $http
                    .get(baseUrl + '/GovernanceProcess/Active')
                    .then(function(response) {return response.data;});
            },

            getProcessType: function () {
                return $http
                    .get(baseUrl + '/GovernanceProcess/Type')
                    .then(function (response) { return response.data; });
            }
        }
    }
})();
